import { PanelRow } from "@wordpress/components";
import { TextControl } from "@wordpress/components";
import { SelectControl } from "@wordpress/components";
import { PanelBody } from "@wordpress/components";
import { __experimentalBorderControl as BorderControl } from "@wordpress/components";
import React from "react";
import { BMediaUpload, BUnitControl } from "../../../../../../wp-utils/v1/components";
import { Button } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { produce } from "immer";

const Items = ({ updateVideo, setAttributes, videos }) => {
  const defaultItemValue = {
    videoSource: "https://www.youtube.com/watch?v=aqz-KE-bpKQ&pp=ygUOYmlnIGJ1Y2sgYnVubnk%3D",
    videoThumb: "",
    heading: "Heading",
    content:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt reprehenderit nulla nisi repudiandae similique, esse hic impedit maiores corporis odit incidunt cumque molestiae quidem. Quod temporibus, sint esse amet est dicta earum itaque quasi quia maiores dolores quos porro sequi.",
    border: {
      width: "22px",
      style: "solid",
      color: "#73E2FE",
    },
    borderColor: "#ffddcc",
    videoPosition: "left",
    borderRadius: "15px",
  };

  const addNewTimelineItem = () => {
    const newVideos = produce(videos, (draft) => {
      draft.push({ ...defaultItemValue, videoPosition: videos[videos.length - 1].videoPosition == "left" ? "right" : "left" });
    });

    setAttributes({ videos: newVideos });
  };
  return (
    <PanelBody title={__("Items", "ytp")} initialOpen={false}>
      {videos.length ? (
        videos.map((item, index) => (
          <PanelBody title={`Item ${index + 1}`} key={`video${index}`} initialOpen={false}>
            {/* <label></label>
            <PanelRow>
            </PanelRow> */}
            <TextControl
              value={item.videoSource}
              label={__("Video Source", "ytp")}
              placeholder={__("Video Source", "ytp")}
              onChange={(value) => updateVideo("videoSource", value, index)}
            />

            <BMediaUpload
              value={item.videoThumb}
              placeholder={__("Youtube Video Thumbnail", "ytp")}
              onSelect={(value) => updateVideo("videoThumb", value, index)}
              label={__("Video Thumbnail", "ytp")}
              type="image"
            />
            {/* <PanelRow className="mb-0">
              <label>{__("Video Position", "ytp")}</label> */}
            <SelectControl
              label={__("Video Position", "ytp")}
              options={[
                { label: "left", value: "left" },
                { label: "Right", value: "right" },
              ]}
              value={item.videoPosition}
              onChange={(value) => updateVideo("videoPosition", value, index)}
            />
            {/* </PanelRow> */}
            <PanelRow>
              <BorderControl value={item.border} onChange={(nextValues) => updateVideo("border", nextValues, index)} label={__("Border", "ytp")} />
            </PanelRow>
            {/* <PanelRow>
              <label>{__("Border Radius", "ytp")}</label> */}
            <BUnitControl label={__("Border Radius", "ytp")} value={item.borderRadius} onChange={(value) => updateVideo("borderRadius", value, index)} />
            {/* </PanelRow> */}
            <PanelRow>
              <Button
                variant="primary"
                onClick={() =>
                  setAttributes({
                    videos: produce(videos, (draft) => {
                      draft.splice(index, 0, defaultItemValue);
                    }),
                  })
                }
              >
                {/* {__("Duplicate", "ytp")} */}
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 3h12v4h4v14H7v-4H3V3h2zm10 4V5H5v10h2V7h8zM9 17v2h10V9H9v8z" fill="#fff" />
                </svg>
              </Button>
              <Button
                variant="primary"
                onClick={() =>
                  setAttributes({
                    videos: produce(videos, (draft) => {
                      draft.splice(index, 1);
                    }),
                  })
                }
                style={{ background: "#a90c0c" }}
                className="btnDanger"
                icon="trash"
              >
                {/* {__("Remove", "ytp")} */}
              </Button>
            </PanelRow>
          </PanelBody>
        ))
      ) : (
        <h3>{__("No Item Found", "ytp")}</h3>
      )}
      <PanelRow>
        <span></span>
        <Button variant="primary" onClick={addNewTimelineItem}>
          {__("Add New", "ytp")}
        </Button>
      </PanelRow>
    </PanelBody>
  );
};

export default Items;
